import st from "./loading.module.css"
function Loading() {
    return ( <div style={{ height : "100vh" }} className={st.container}>
        <span> <span className={st.loader}></span> </span>
    </div> );
}

export default Loading;